
import dust from "dustjs-linkedin";


(function(){dust.register("app",body_0);function body_0(chk,ctx){return chk.write("<section class=\"app-main\"><section class=\"app-content\"></section></section><section class=\"fast-tracking-messages hidden\"></section><section class=\"app-cookie-consent\"></section><section class=\"app-messages\"></section><section class=\"app-home-drawer\"></section><section class=\"app-toaster\"></section><section class=\"app-settings\"></section><section class=\"app-debug\"></section><section class=\"app-header\"></section>");}return body_0;})();

export default 0;
